var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { HeaderComponent } from './header.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
// import * as UserActions from '../../../store/actions/user.actions';
import { takeWhile } from 'rxjs/operators';
var INDRAHeaderComponent = /** @class */ (function (_super) {
    __extends(INDRAHeaderComponent, _super);
    function INDRAHeaderComponent(router, route, store) {
        var _this = _super.call(this) || this;
        _this.router = router;
        _this.route = route;
        _this.store = store;
        _this.isAlive = true;
        _this.mobileMediaQuerieSize = 1025;
        _this.showFallback = false;
        _this.isLoading = true;
        _this.isLandingPage = false;
        // urlQueryParamsRead: boolean = false;
        _this.transparentHeaderRoutes = [
            '/my-bookings',
            '/my-bookings/details',
            '/my-bookings/view',
            '/dummypage'
        ];
        _this.transparentDesktopHeaderRoutes = [
            '/booking',
            '/corporate'
        ];
        // private fallback_header$: Observable<boolean> = this.store.select(fromStore.getFallbackHeader);
        _this.user_loading$ = _this.store.select(fromStore.getUserLoading);
        _this.confirmDialog$ = _this.store.select(fromStore.getConfirmDialog);
        _this.current_page$ = _this.store.select(fromStore.getSelectedBookingCurrentPage);
        _this.getScreenSize();
        _this.router.events.subscribe(function (event) {
            _this.getHeaderStyles();
        });
        _this.current_page$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isLandingPage = value == null;
            if (value != null)
                document.querySelector('header').classList.add('not-landing');
            else
                document.querySelector('header').classList.remove('not-landing');
        });
        return _this;
    }
    INDRAHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.user_loading$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.isLoading = value;
        });
    };
    INDRAHeaderComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAHeaderComponent.prototype.getHeaderStyles = function () {
        var routerTree = this.router.parseUrl(this.router.url);
        var queryParams = routerTree.queryParams;
        routerTree.queryParams = {};
        var forceTransparentHeader = false;
        var routeUrl = routerTree.toString();
        if (routeUrl.includes('/my-bookings/details/')) {
            routeUrl = '/my-bookings/details';
        }
        if (routeUrl.includes('/my-bookings/view/')) {
            if (queryParams.notification === 'purchase-completed' || queryParams.notification === 'time-to-think') {
                forceTransparentHeader = true;
            }
        }
        var body = document.getElementsByTagName('body')[0];
        if (this.transparentHeaderRoutes.filter(function (route) { return routeUrl === route; }).length > 0 || forceTransparentHeader) {
            body.classList.add('mod-hp');
        }
        else {
            body.classList.remove('mod-hp');
        }
        if (this.transparentDesktopHeaderRoutes.filter(function (route) { return routeUrl === route; }).length > 0) {
            body.classList.add('mod-hp--dekstop-only');
            if (this.showHeader === 'desktop') {
                body.classList.add('mod-hp');
            }
        }
        else {
            body.classList.remove('mod-hp--dekstop-only');
        }
        // Corporate
        if (routeUrl.includes('/corporate')) {
            body.classList.add('is-corporate');
        }
        else {
            body.classList.remove('is-corporate');
        }
    };
    INDRAHeaderComponent.prototype.getScreenSize = function (event) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < this.mobileMediaQuerieSize) {
            this.showHeader = 'mobile';
        }
        else {
            this.showHeader = 'desktop';
        }
        this.getHeaderStyles();
    };
    return INDRAHeaderComponent;
}(HeaderComponent));
export { INDRAHeaderComponent };
